import { TAI_FU_30_INDEX_CODE } from "@/app/lib/enums";
export function isTaiFuIndex(
   symbol: string | TAI_FU_30_INDEX_CODE,
   descriptionOrName: string
): boolean {
   const isMatchingTaiFuIndexCode = Object.values(TAI_FU_30_INDEX_CODE).includes(
      symbol as TAI_FU_30_INDEX_CODE
   );
   if (isMatchingTaiFuIndexCode) {
      return true;
   }

   const descriptionLower = descriptionOrName.toLowerCase();

   const hasTaiFuAndIndex =
      descriptionLower.includes("taifu") && descriptionLower.includes("index");

   const hasTaiFuWithNumber =
      descriptionLower.includes("taifu") &&
      (descriptionLower.includes(" 30") ||
         descriptionLower.includes(" 20") ||
         /\btaifu\s*(™)?\s*[0-9]+\b/i.test(descriptionOrName));

   const ratioPattern = /\b\d+\s*[:/\s\-_]\s*\d+\b/;
   const hasTaiFuWithRatio =
      descriptionLower.includes("taifu") &&
      (descriptionLower.includes("80:20") ||
         descriptionLower.includes("80 20") ||
         descriptionLower.includes("80/20") ||
         descriptionLower.includes("70:30") ||
         descriptionLower.includes("70 30") ||
         descriptionLower.includes("70/30") ||
         descriptionLower.includes("60:40") ||
         descriptionLower.includes("60 40") ||
         descriptionLower.includes("60/40") ||
         ratioPattern.test(descriptionOrName));

   return hasTaiFuAndIndex || hasTaiFuWithNumber || hasTaiFuWithRatio;
}

export function isBitcoinDominance(codeOrName: string): boolean {
   const normalized = codeOrName?.toLowerCase() || "";
   return (
      normalized === "btcdominance" ||
      normalized.includes("bitcoin dominance") ||
      normalized.includes("btc dominance") ||
      normalized.includes("chỉ số thống trị")
   );
}

export function getValueUnitAndTerm(
   symbol: string | TAI_FU_30_INDEX_CODE,
   name: string
): { unit: string; valueTerm: string; formatValue: (value: number) => string } {
   if (isBitcoinDominance(symbol) || isBitcoinDominance(name)) {
      return {
         unit: "%",
         valueTerm: "Percentage",
         formatValue: (value: number) => `${value.toLocaleString()}%`
      };
   } else if (isTaiFuIndex(symbol, name)) {
      return {
         unit: "Point",
         valueTerm: "Point",
         formatValue: (value: number) => value.toLocaleString()
      };
   } else {
      return {
         unit: "USD",
         valueTerm: "Price",
         formatValue: (value: number) => `$${value.toLocaleString()}`
      };
   }
}
